import React from 'react';
import { FileTextIcon } from 'lucide-react';
import { TextButton } from '../TextButton';
import { smsMessages } from '../../utils/sms';
export function TaxNotice() {
  return <section className="bg-paper py-16 lg:py-20" data-id="element-162" data-mp="z3dvtv8i16wh">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-163" data-mp="z4oz7ty18cn2">
        <div className="grid gap-8 rounded-2xl bg-canvas p-8 ring-1 ring-ink-950/8 lg:grid-cols-[auto_1fr_auto] lg:items-center lg:gap-12 lg:p-10" data-id="element-164" data-mp="1428cormwoldy">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-ink-950 text-white" data-id="element-165" data-mp="7dsnwxrmeg1w">
            <FileTextIcon className="h-5 w-5" aria-hidden="true" data-id="element-166" data-mp="be2qs1k48qcj" />
          </span>

          <div data-id="element-167" data-mp="gbcpy8xb4gdk">
            <h2 className="font-display text-xl font-semibold tracking-tight text-ink-950 lg:text-2xl" data-id="element-168" data-mp="gbl0hu5yj9ll">
              Hydrosprings will qualify as a tax-deductible medical device
            </h2>
            <p className="mt-3 max-w-2xl text-[15px] leading-relaxed text-ink-700" data-id="element-169" data-mp="3jtcqx44g3lho">
              Under IRS Publication 502, devices used to prevent or reduce
              exposure to harmful substances &mdash; such as chlorine, listed by
              the EPA as a pesticide &mdash; can be tax-deductible. Hydrosprings
              reduces your family&rsquo;s exposure to these chemicals, helping
              protect against risks like asthma, hormone disruption,
              reproductive harm and certain cancers.
            </p>
            <p className="mt-3 text-[13px] text-ink-400" data-id="element-170" data-mp="gq6nt2mgs8k">
              Contact your tax expert about how to claim this deduction.
            </p>
          </div>

          <TextButton message={'Hi Hydrosprings \u2014 can you send the tax deduction details?'} variant="outline" className="shrink-0" data-id="element-171" data-mp="3rlycx676v6ep">
            Text us
          </TextButton>
        </div>
      </div>
    </section>;
}